import React, { Component } from 'react';
import classNames from 'classnames';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { 
  AddToCartButton, 
  BusyContainer, 
  CloneButton, 
  ConfigureButton,
  ExportCartPanel,
  GoToButton, 
  IconButton, 
  QuantityField, 
  RemoveButton, 
  SuperCode 
} from '..';
import { translate } from '../../services';
import { cartDispatcher, combineDispatchers, popupDispatcher, identityState, apttusDispatcher, 
  combineStates, priceState, productState, superCodeState, siteSettingsState, popupState,currentNodeState, dialogReducer, dialogState, dialogDispatcher,modelConfiguratorDispatcher,modelConfiguratorState, currentPageState, messageDispatcher,
  cartState} from '../../store';
import { calculateAmount, getIncrementByAmount, getMinOrderAmount, preProcessProducts, getAccessories, hasBomItemAssignment, getUserAssignments } from '../../util';
import { PopupMessage, PopupType } from '../PopupMessage';
import { ExportToApttus } from '../ExportToApttus';
import { copyIcon,downloadIcon, CloseIconNew, EditIConNew, DuplicateIconNew, TrashIconNew, SettingsIconNew, TrashWhiteIconNew, CartIconNew, WhiteCartIconNew, closePopup, mobileClosePopup,deliveryOptionIcon, NewDeliveryIcon, NoteIcon } from '../../../style/images';
import { Box, Dialog, IconButton as MuiIconButton } from '@mui/material';
import copy from "copy-to-clipboard";
const defaultRequiredMissingKey = `'Your product has a suggested item for {field}, but your selection hasn\'t 
          identified which item it should be.\n\n' + 'Do you wish to add your item without a selected accessory to the cart?'`;

export class ActionPanelComponent extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      openModal:false,
      showQuantityField:false,
      showItemActions: false,
      showCommentDialog: false,
      comment:"",
    };
  }

  toggleCommentDialog(item){
    this.setState({showCommentDialog:!this.state.showCommentDialog})
    if(item ){
      this.setState({comment:item[item.length-1]?.noteByUser});
    }
  }

  static getDerivedStateFromProps( props, state = {} ) {
    if (!state || state.code !== props.product.code ) {
      state = {};
    }
    const code = props.product.code;
    const isBomItemMain = props.fromModelConfigurator && props.product?._bom?.properties?.IsBomItemMain;
    const incrementBy = state.incrementBy || ( props.product ? getIncrementByAmount( props.product ) : 1 );
    const minOrderAmount = state.minOrderAmount || 
    (props.fromModelConfigurator ? 
      (isBomItemMain ? 1 : (isNaN(props.defaultAmount) ? 1 : props.defaultAmount)) : 
      (props.product ? getMinOrderAmount( props.product ) : 1 )
    );
    // let amount = props.product.isSuperConfiguration ? props.product.amount 
    //               : state.amount || props.product.amount || minOrderAmount;

	// TODO: second line was commented in Dev branch. To check the impact.
    let amount = props.product.isSuperConfiguration ? props.product.amount : 
    (props.fromModelConfigurator ? props.modelConfigurator[code] || minOrderAmount : 
    (props.fromCart ? props.product.amount || state.amount || minOrderAmount : state.amount || props.product.amount || minOrderAmount));
    let amountFn = state.amountFn;
    if (state.incrementBy !== incrementBy || state.minOrderAmount !== minOrderAmount) {
      amountFn = calculateAmount( minOrderAmount, incrementBy );
      amount = amountFn( amount );
    }

    return {
      amount,
      incrementBy,
      minOrderAmount,
      amountFn,
      code
    };
  }

  close = ()=>{
    this.setState({openModal:false})
  }

  open=()=>{
    this.setState({openModal:true})
  }
  confirmBomItemMissing = ( products, resolve, reject ) => {
    const { properties } = this.context;
    const {restrict, translationKey_warning } = properties;
    const {user} = this.props
    // this.props.setPopup( 
    //   {
    //     title: `Add ${ products.select( p => p.name ).join(',') } to the cart?`,
    //     component:  <Dialog open={this.props.popup} onClose={this.props.hidePopup} PaperProps={{sx:{overflow:"hidden"}}}>
    //     <div className='bom-item-missing'>
    //       <div className='content'>
    //         <div className='header'>
    //           <h5>{translate("Mandatory filters required")}</h5>
    //         </div>
    //         <span>{translate("Your product has a suggested item for Trip unit code. Fixed Part ID, Conversation Kit, but your selection hasn’t identified which item it should be. Please select all mandatory fields.")}</span>
    //         <div className='secondary-button' onClick={this.props.hidePopup}>
    //           <span>{translate("Go back")}</span>
    //         </div>
    //       </div>
    //     </div>
    //   </Dialog>,
    //     showHeader: false,
    //     keepOpen: false 
    //   } 
    // );
    this.props.showDialog(
      <div className='bom-item-missing'>
           <div className='content'>
           <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={this.props.closeDialog} style={{width:"24px", height:"24px"}} sx={{display:"flex",position:"absolute", top:"12px", right:"12px", background:"#F5F5F5", height:"20px", width:"20px", borderRadius:"56px" , backgroundColor: 'white'}}>
              <Box component="img" src={closePopup} sx={{width:{md:'24px', xs:"18px"}, height: {md:'24px', xs:"18px"}}}></Box>
            </MuiIconButton>
             <div className='header'>
               <h5>{translate("Mandatory filters required")}</h5>
             </div>
             <span>{translate(translationKey_warning || defaultRequiredMissingKey, { field: products?.select( p => p.bomItemFields.map( key => p.translations[key] || key )
              .join(',') ).firstOrDefault() })}</span>
             <Box sx={{width:"100%", display:"flex", justifyContent:"flex-end", height:"max-content", gap:"8px"}}>
                <div className='secondary-button' onClick={()=>{
                  if(reject){
                    reject( { dismissed: true } ); this.props.closeDialog();
                  }
                  else{
                    this.props.closeDialog();
                  }
                  }}>
                  <span>{translate("Go back")}</span>
                </div>
                {(user.country.toLowerCase()==='de' || user.country.toLowerCase()==='decbol') && <div className='secondary-button' onClick={restrict ? ()=>{this.props.closeDialog()} : () => {resolve( products ); this.props.closeDialog()}}>
                  <span>{translate("Okay")}</span>
                </div>}
             </Box>
          </div>
         </div>,
         "bom-item-missing"
    )
    this.open()
  };

  // confirmBomItemMissing = ( products, resolve, reject ) => {
  //   const { properties } = this.context;
  //   const {restrict, translationKey_warning } = properties;
  //   this.props.setPopup( 
  //     {
  //       title: `Add ${ products.select( p => p.name ).join(',') } to the cart?`,
  //       component: <PopupMessage
  //         text={ translate( translationKey_warning || defaultRequiredMissingKey, 
  //           { field: products.select( p => p.bomItemFields.map( key => p.translations[key] || key )
  //             .join(',') ).firstOrDefault() } ) } 
  //         actionText={ translate( 'Continue' ) } 
  //         cancelText={ translate( 'Go back' ) }
  //         onClick={ restrict ? null : () => resolve( products ) }
  //         popupType={ PopupType.Info }
  //         onClose={ () => reject( { dismissed: true } ) }
  //       />,
  //       showHeader: false,
  //       keepOpen: false 
  //     } 
  //   );
  // };
  
  warnSuggestedItemNotAvailableInLocale = ( products, resolve, reject ) => {
    // reject directly, with an error
    reject( `'The product you want to add to the cart has a suggested accessory that is not available in your locale!
      \r\nPlease open the product in the configurator and add it to the cart from the configurator!'` );
  };

  onCancel = () => {
    const { cancel } = this.props;
    cancel.onClick && cancel.onClick();
  }

  changeAmount = amount => {
    const { fromCart,fromModelConfigurator, product, quantity } = this.props;
    const { onAmountChange } = this.context;
    this.setState( { amount } );
    if( fromCart ) {
      this.props.setNewAmount( product, amount );
    }
    if( fromModelConfigurator ) {
      this.props.setNewAmountToQuantityList( this.props.modelConfigurator,product.code, amount );
    }
    onAmountChange && onAmountChange( amount, product );
    quantity.onChange && quantity.onChange.apply && quantity.onChange( amount );
  }

  fixAmount = ( amount ) => {
    const { amountFn } = this.state;
    const targetAmount = amountFn( amount );
    if (targetAmount !== amount) {
      this.changeAmount( targetAmount );
    }
  }

  apptusAction = () => {
    const { prices, product, user, isReadyAssembled } = this.props;
    this.props.setPopup(
      {
        title: `${translate('Saving To Apttus')}`,
        component: <ExportToApttus product={ product } prices={ prices } 
          user={ user } reConfig={ true } isReadyAssembled = {isReadyAssembled} />,
        showHeader: true,
        keepOpen: true
      } );
  }
  openExport = () => {
    const { product, superCode, supercodeIdentified,supercodeAdditionalProduct, isReadyAssembled } = this.props
    let cartproducts = !_.isEmpty( product?.additionalProducts ) 
        ? Array( product, product?.additionalProducts[0] ) : Array( product );
    cartproducts = cartproducts.map( cp => { 
      const accessoryBOM = cp.name.concat(';', getAccessories( cp ).join(';') );
      if(product?.additionalProducts[0] && cp.name===product?.additionalProducts[0].name  ){
       return { ...cp, isReadyAssembled:isReadyAssembled,superCode: !isReadyAssembled?"":supercodeAdditionalProduct? supercodeAdditionalProduct:
        superCode.items.filter( sc => sc.variantId === cp.name && sc.superCode != '1SDX' && sc.bom === accessoryBOM )
      .firstOrDefault()?.superCode}
      }
      else{
      return { ...cp, isReadyAssembled:isReadyAssembled,superCode: !isReadyAssembled?"":supercodeIdentified? supercodeIdentified:
        superCode.items.filter( sc => sc.variantId === cp.name && sc.superCode != '1SDX' && sc.bom === accessoryBOM )
      .firstOrDefault()?.superCode} }} );
    this.props.showDialog( <ExportCartPanel cartItems={ cartproducts } onClose={this.props.closeDialog}/>)
  }

  redirect = () => {
    const apttusUrl = this.props.user.properties["ApttusURL"];
    window.location.href = apttusUrl;
  }

  saveText = ()=>{
    this.props.addNote(this.props.product,this.state.comment);
    this.toggleCommentDialog();
  }

  onCommentChange = (e)=>{
    this.setState({comment:e.target.value})
  }
  onNoteChange=(e)=>{

    this.props.addNote(this.props.product,e.target.value);
    let language='EN';
    if(/\p{sc=Han}/u.test(e.target.value)){
      language='CN';
    }
    let noOfWords= e.target.value.split(' ').length;
    if(language=='EN' && noOfWords==41){
      this.setState({maxLength:e.target.value.length})
    }
    else if(language=='CN' && noOfWords==21){
      this.setState({maxLength:e.target.value.length})
    }
    }
    copyProductType=(e)=>{
      const productType=this.props.product?.configurableProduct?this.props.products[this.props.product.superCodeLSO]?.description:this.props.product?.description
      copy(productType);
     // navigator.clipboard.writeText(productType);
      this.props.addMessage( { timeout: 10000, messageType: 'confirmation', messageText: translate( 'Product type copied to clipboard!' ) } );
  
    }
      createItemUuid=( item )=> {
      if ( !item ) {
        return '';
      } 
    
      const clonedIdx = item.clonedIdx || '';
      const modelToLoad = item.modelToLoad || '';
      let configuration = '';
      let additionalconfiguration = '';
    
      if( item.configuration ) {
        const assignments = getUserAssignments( item.configuration ).orderBy( a => a.key );
        configuration = assignments.select( ass => `${ass.key}-${ass.value}` ).join( '|' );
      }
      if( item.additionalProducts && item.additionalProducts.length > 0 && !item.additionalProducts[0]?.dummyCode  ){
        if( item.additionalProducts[0].configuration ) {
          const additionalassignments = getUserAssignments( item.additionalProducts[0].configuration ).orderBy( a => a.key );
          additionalconfiguration = additionalassignments.select( ass => `${ass.key}-${ass.value}` ).join( '|' );
        }
        return `${clonedIdx}_${item.name}_${configuration}_${modelToLoad}_MP+FP_${item.additionalProducts[0].name}_${additionalconfiguration}_${item.deliveryOption}`;
      }
      if( item.looseadditionalProduct && item.looseadditionalProduct.length>0 ){
        if( item.looseadditionalProduct[0].configuration ) {
          const additionalassignments = getUserAssignments( item.looseadditionalProduct[0].configuration ).orderBy( a => a.key );
          additionalconfiguration = additionalassignments.select( ass => `${ass.key}-${ass.value}` ).join( '|' );
        }
        return `${clonedIdx}_${item.name}_${configuration}_${modelToLoad}_MP+FP_${item.looseadditionalProduct[0].name}_${additionalconfiguration}_${item.deliveryOption}`;
      }
      
      return `${clonedIdx}_${item.name}_${configuration}_${modelToLoad}_${item.deliveryOption}`;
    }
  openQuantityField = ()=>{
    const {product, siteSettings} = this.props;
    const warnPopup = siteSettings.properties?.showPopup;
    const {properties = { allSatisfied: true } } = this.context;
    if(this.getWarningComponent(properties.allSatisfied === false && product.bomItems !== undefined, product, warnPopup)){
      this.confirmBomItemMissing()
    }else{
      this.setState({showQuantityField:!this.state.showQuantityField})
    }
   
  }

  getWarningComponent( showWarning, product, warnPopup ) {
    if (showWarning && !warnPopup ) {
      // return <span key="warning" className="floating outward" title={translate('missing_bom_item')}>!</span>
      return true;
    }
    return false;
  }

  render() {
    const { 
      add, 
      cancel, 
      className, 
      clone, 
      configure,
      exportOptions,
      fromCart, 
      isPopup, 
      oldProduct, 
      product,
      products,
      quantity, 
      remove, 
      superCodeOptions,
      isReadyAssembled,
      assemblyType,
      supercodeIdentified,
      fromModelConfigurator,
      warning,user,siteSettings,atsl,fromSearch,isEdit,currentNode,deliveryOption,
      deliveryWarning,fromConfigFooter,cart,onConfigure,FG,fromSelect
    } = this.props;
    const { amount, amountFn } = this.state;
    const { getGoToConfig, properties = { allSatisfied: true } } = this.context;
    const goTo = getGoToConfig && getGoToConfig( product );
    const classes = classNames( 'action-panel', className );
    const CbolAddToList = siteSettings.addToShoppingListForCbol;
    const warnPopup = currentNode?.customProperties?.HidePopup;
    const apttusReconfig = user.properties["Action"] === "Reconfig";
    const bolReconfig = user.properties["Action"] === "reconfig" && user.properties.CallingApp === "BOL";
    let mountedOnly = false;
    const hideGotoProduct=siteSettings?.properties?.hideGotoProduct;
    if(product.deliveryOption){
      if(deliveryWarning){deliveryWarning=true};
    }
    let cartkey=this.createItemUuid(product)
    let item=Object.keys( cart ).filter( key => key == cartkey ).map( key => ( { ...cart[key].product, amount: cart[key].quantity,noteByUser:cart[key].product?.noteByUser } ) );
   
    if( product && product.properties && product.properties.find(p => p?.name == "MountedOnly") != undefined){
     mountedOnly = product.properties.find(p => p?.name == "MountedOnly").value;
    }
    let classNameWarning = 'disable';
    if (product.configuration != undefined || product.configuration != null) {
      if (product.assignments.length != 0) {
        classNameWarning = 'disable';
      } else {
        if (product.configuration.assignments != '') {
          let assignmetsMap = new Map();
          let assignmets = product.configuration.assignments;
          for ( let k = 0; k < assignmets.length; k++ ) {
            assignmetsMap.set(assignmets[k].key, "");
          }
          let variables = [];
          let missedManditoryFields = [];
          variables = product.configuration.model.children[0].variables;
          for (let k = 0; k < variables.length; k++) {
            let variable = variables[k];
            if (variable.properties.Required && !variable.assignedValue) {
              if (!assignmetsMap.has(variable.fullyQualifiedName)) {
                missedManditoryFields.push(variable.fullyQualifiedName);
              }
            }
          }
          //set error message hear for each configuration
          if (missedManditoryFields.length > 0) {
            classNameWarning = 'warningIcon';
          } else {
            classNameWarning = 'disable';
          }
        }
      }
    }
    const hidden = !product.isConfigurable && ( !product.materialName || product.materialName === product.name )

    const showMobileAddToCartButtonCN = product.properties?.any(p=>p.name=='Emax 2 Fixed Parts') ? true: product.properties.any(p=>p.name=='Emax 2' || (p.name=='SelectorName' && p.value=="Emax 2")) && !product.configurableProduct && !onConfigure?false: product.properties.any(p=>p.name=='VD4_MB' || p.name=='iVD4_MB') && !onConfigure?false:product.configurableProduct || onConfigure || (fromSearch && product.configurableProduct );
    return(<>
            {/* <Dialog sx={{display:{md:none, xs:"flex"}}} open={this.state.openModal} onClose={this.close} PaperProps={{sx:{overflow:"hidden"}}}>
              <div className='bom-item-missing'>
                <div className='content'>
                  <div className='header'>
                    <h5>{translate("Mandatory filters required")}</h5>
                  </div>
                  <span>{translate("Your product has a suggested item for Trip unit code. Fixed Part ID, Conversation Kit, but your selection hasn’t identified which item it should be. Please select all mandatory fields.")}</span>
                  <div className='secondary-button' onClick={this.close}>
                    <span>{translate("Go back")}</span>
                  </div>
                </div>
              </div>
            </Dialog> */}
        <div className={ classes }>
        {!this.props.mobileSearchView?
        <>
        {this.props.modelconfiguratorquantity? null : <div className='action-panel-item1-container'>
        <div className="action-panel-item1">
      {/* {fromCart && !fromConfigFooter &&<input type='text' className='note_by_user' onChange={this.onNoteChange} value={item[item.length-1]?.note} maxLength={this.state.maxLength}/>}   */}
      {warning && ( <span className={ classNameWarning } title='Reconfiguration is required' /> ) }
      {fromCart&&(product.deliveryOption=="YES" ? ( <Box component="img" sx={{width:"24px", height:"24px", margin:"5px"}} src={NewDeliveryIcon} title={translate('Deliver as finish good')}/> ):<Box sx={{width:"24px", height:"24px", margin:"5px"}}/> )}
      { !hideGotoProduct && goTo && <GoToButton { ...goTo } /> }
      {!fromCart && !fromConfigFooter &&<IconButton className="round-button" tooltip={translate('Copy Product type')} icon={copyIcon} onClick={this.copyProductType} />}  
      { remove && <RemoveButton { ...remove } product={ product } fromCart={ fromCart } icon={fromCart?TrashWhiteIconNew:null} /> }
      { clone && <CloneButton { ...clone } product={ product } /> }
      { configure && <ConfigureButton { ...configure } fromCart={ fromCart } 
        product={ Object.assign(product,{amount}) } 
        products={ products }
        fromSearch = { fromSearch } /> }
      {/* { quantity &&
            <QuantityField 
              amount={ quantity.amount || amount }
              onChange={ this.changeAmount }
              onBlur={ this.fixAmount } 
              minOrderAmount = { this.state.minOrderAmount }
              incrementBy = { this.state.incrementBy }
              { ...product }
              disabled={ quantity.disabled }
              hidden={ quantity.hidden }
              readonly={ quantity.readonly || product.fixedAmount }
            /> } */}
      {/* { remove && <RemoveButton { ...remove } product={ product } fromCart={ fromCart } /> }
      { clone && <CloneButton { ...clone } product={ product } /> } */}
      { superCodeOptions && <SuperCode {...superCodeOptions} product={ product }/>}
      { cancel &&
                // <IconButton 
                //   className="tertiary-button" 
                //   onClick={ apttusReconfig ? this.redirect : this.onCancel } 
                //   text={ cancel.text || 'Cancel' } 
                //   tooltip={ translate( cancel.text || 'Cancel' ) }
                //   disabled={ cancel.disabled }
                //   hidden={ cancel.hidden }
                // />
                <div className="tertiary-button" onClick={ apttusReconfig ? this.redirect : this.onCancel } disabled={ cancel.disabled }
                hidden={ cancel.hidden }>
                                        <span>{translate("Cancel")}</span>
                                    </div> }
      {/* { CbolAddToList && <AddToCartButton 
            // { ...atsl }
            { ...add }
            shoppingList 
            showWarning={ properties.allSatisfied === false && product.bomItems !== undefined }
              product={ product } 
              process={ preProcessProducts( product, { 
                warnMissingBomItems: this.confirmBomItemMissing, 
                warnSuggestedItemNotAvailableInLocale: this.warnSuggestedItemNotAvailableInLocale 
              } ) }
              fromCart={ fromCart } 
              oldProduct={ oldProduct } 
              isPopup={ isPopup } 
              amount={ amount } 
              fixAmountFunc={ amountFn }
              isReadyAssembled={ isReadyAssembled } 
              assemblyType = { assemblyType }
              // disabled = { atsl.disabled || mountedOnly }
              className="add-to-shopping-cart" 
              text={ 'Shopping List' }
              tooltip={ translate( 'Add to shopping list' ) } /> 
        } */}
     
      { exportOptions && !exportOptions.disabled && exportOptions.fromCbol && exportOptions.showExport &&
            <IconButton 
              className="primary-button" 
              icon={ downloadIcon } 
              text={ translate( 'Export configuration' ) } 
              onClick={ this.openExport } 
            /> 
      }
      { atsl && CbolAddToList && <AddToCartButton 
            { ...atsl }
            // { ...add }
            shoppingList 
            showWarning={ properties.allSatisfied === false && product.bomItems !== undefined }
              product={ product } 
              process={ preProcessProducts( product, { 
                warnMissingBomItems: this.confirmBomItemMissing, 
                warnSuggestedItemNotAvailableInLocale: this.warnSuggestedItemNotAvailableInLocale 
              },this.props.currentPage.currentPage) }
              fromCart={ fromCart } 
              oldProduct={ oldProduct } 
              isPopup={ isPopup } 
              amount={ amount } 
              fixAmountFunc={ amountFn }
              isReadyAssembled={ isReadyAssembled } 
              assemblyType = { assemblyType }
              disabled = { atsl.disabled || mountedOnly }
              className="add-to-shopping-cart" 
              text={ 'Shopping List' }
              tooltip={ translate( 'Add to shopping list' ) } 
              fromSearch = { fromSearch }
              currentSelector={this.props.currentSelector}
              fromLooseAccessories={this.props.fromLooseAccessories}
              fromSearchOverlay={this.props.fromSearchOverlay}
              mobileSearchView={this.props.mobileSearchView}
              fromModelConfiguratorSelector = {this.props.fromModelConfiguratorSelector}
              isEdit = {isEdit}
              deliveryOption={deliveryOption}
              FG={FG}
              visibility={product.properties.any(p=>p.name=='Emax 2 Fixed Parts') ? true: product.properties.any(p=>p.name=='Emax 2' || (p.name=='SelectorName' && p.value=="Emax 2")) && !product.configurableProduct && !onConfigure?false: product.properties.any(p=>p.name=='VD4_MB' || p.name=='iVD4_MB') && !onConfigure?false:product.configurableProduct || onConfigure || (fromSearch && product.configurableProduct )}
              fromConfigFooter={fromConfigFooter}
              fromSelect={fromSelect} /> 
        }
      { !bolReconfig &&!apttusReconfig && add && <AddToCartButton 
                  { ...add } 
                  showWarning={ properties.allSatisfied === false && product.bomItems !== undefined }
                  product={ product } 
                  process={ preProcessProducts( product, { 
                    warnMissingBomItems: this.confirmBomItemMissing, 
                    warnSuggestedItemNotAvailableInLocale: this.warnSuggestedItemNotAvailableInLocale 
                  }, this.props.currentPage.currentPage ) }
                  fromCart={ fromCart } 
                  oldProduct={ oldProduct } 
                  isPopup={ isPopup } 
                  amount={ amount } 
                  fixAmountFunc={ amountFn }
                  isReadyAssembled={ isReadyAssembled } 
                  assemblyType = { assemblyType }
                  supercodeIdentified = { supercodeIdentified }
                  disabled = { add.disabled || mountedOnly }
                  fromSearch = { fromSearch }
                  warnPopup = { warnPopup }
                  fromConfigurator = {this.props.fromConfigurator}
                  fromModelConfigurator = {this.props.fromModelConfigurator}
                  defaultAmount = {this.props.defaultAmount}
                  fromModelConfiguratorFooter = {this.props.fromModelConfiguratorFooter}
                  hasAccessories = {this.props.hasAccessories}
                  currentSelector={this.props.currentSelector}
                  fromLooseAccessories={this.props.fromLooseAccessories}
                  fromSearchOverlay={this.props.fromSearchOverlay}
                  mobileSearchView={this.props.mobileSearchView}
                  isEdit = {isEdit}
                  fromModelConfiguratorSelector = {this.props.fromModelConfiguratorSelector}
                  deliveryOption={deliveryOption}
                  FG={FG}
                  visibility={product.properties.any(p=>p.name=='Emax 2 Fixed Parts') ? true: product.properties.any(p=>p.name=='Emax 2' || (p.name=='SelectorName' && p.value=="Emax 2")) && !product.configurableProduct && !onConfigure?false: product.properties.any(p=>p.name=='VD4_MB' || p.name=='iVD4_MB') && !onConfigure?false:product.configurableProduct || onConfigure || (fromSearch && product.configurableProduct )}
                  fromConfigFooter={fromConfigFooter}
                  fromSelect={fromSelect} />
      }
      { apttusReconfig && <IconButton className="blue-button" icon={ downloadIcon } 
        text={ translate( 'Save To Apttus' ) } onClick={ this.apptusAction } />}
      { bolReconfig && <IconButton className="blue-button" 
        icon={ downloadIcon } text={ translate( 'Save To BOL' ) } onClick={ this.apptusAction } />} 
        </div></div>}
        {!this.props.fromConfigurator?!fromCart?<div className="action-panel-item2">
        { quantity &&
            <QuantityField 
              amount={ quantity.amount || amount }
              onChange={ this.changeAmount }
              onBlur={ this.fixAmount } 
              minOrderAmount = { this.state.minOrderAmount }
              incrementBy = { this.state.incrementBy }
              { ...product }
              disabled={ quantity.disabled }
              hidden={ quantity.hidden }
              readonly={ quantity.readonly || product.fixedAmount }
              fromModelConfigurator = {fromModelConfigurator}
            /> }
        </div>:
        <div className="action-panel-item2">
          <div className='action-panel-item3'>
        { quantity &&
            <QuantityField 
              amount={ quantity.amount || amount }
              onChange={ this.changeAmount }
              onBlur={ this.fixAmount } 
              minOrderAmount = { this.state.minOrderAmount }
              incrementBy = { this.state.incrementBy }
              { ...product }
              disabled={ quantity.disabled }
              hidden={ quantity.hidden }
              readonly={ quantity.readonly || product.fixedAmount }
              fromModelConfigurator = {fromModelConfigurator}
            /> }
            </div>
            <div className='action-panel-item3'>
            {fromCart && !fromConfigFooter &&<input type='text' className='note_by_user' onChange={this.onNoteChange} value={item[item.length-1]?.noteByUser||''} maxLength={this.state.maxLength}/>}  
            </div>
        </div>:<></>}
        </>:<>
        {!this.props.mobileCartView?<>
          <div className="action-panel-item1" style={{width:"100%", padding:"0px"}}>
            {warning && ( <span className={ classNameWarning } title='Reconfiguration is required' /> ) }
          { !hideGotoProduct && goTo && <GoToButton { ...goTo } /> }
          {!fromCart && !fromConfigFooter &&<IconButton className="round-button" tooltip={translate('Copy Product type')} icon={copyIcon} onClick={this.copyProductType} />}  
          { remove && <RemoveButton { ...remove } product={ product } fromCart={ fromCart } /> }
          { clone && <CloneButton { ...clone } product={ product } /> }
          { configure && <ConfigureButton { ...configure } fromCart={ fromCart } 
            product={ Object.assign(product,{amount}) } 
            products={ products } /> }
          { superCodeOptions && <SuperCode {...superCodeOptions} product={ product }/>}
          { cancel &&
                <div className="tertiary-button" onClick={ apttusReconfig ? this.redirect : this.onCancel } disabled={ cancel.disabled }
                hidden={ cancel.hidden }>
                                        <span>{translate("Cancel")}</span>
                                    </div> }
        
          { exportOptions && !exportOptions.disabled && exportOptions.fromCbol && exportOptions.showExport &&
                <IconButton 
                  className="primary-button" 
                  icon={ downloadIcon } 
                  text={ translate( 'Export cart' ) } 
                  onClick={ this.openExport } 
                /> 
          }
          { atsl && CbolAddToList && <AddToCartButton 
                { ...atsl }
                // { ...add }
                shoppingList 
                showWarning={ properties.allSatisfied === false && product.bomItems !== undefined }
                  product={ product } 
                  process={ preProcessProducts( product, { 
                    warnMissingBomItems: this.confirmBomItemMissing, 
                    warnSuggestedItemNotAvailableInLocale: this.warnSuggestedItemNotAvailableInLocale 
                  }, this.props.currentPage.currentPage ) }
                  fromCart={ fromCart } 
                  oldProduct={ oldProduct } 
                  isPopup={ isPopup } 
                  amount={ amount } 
                  fixAmountFunc={ amountFn }
                  isReadyAssembled={ isReadyAssembled } 
                  assemblyType = { assemblyType }
                  disabled = { atsl.disabled || mountedOnly }
                  className="add-to-shopping-cart" 
                  text={ 'Shopping List' }
                  tooltip={ translate( 'Add to shopping list' ) } 
                  fromSearch = { fromSearch }
                  currentSelector={this.props.currentSelector}
                  fromLooseAccessories={this.props.fromLooseAccessories}
                  fromSearchOverlay={this.props.fromSearchOverlay}
                  mobileSearchView={this.props.mobileSearchView}
                  isEdit = {isEdit}
                  fromModelConfiguratorSelector = {this.props.fromModelConfiguratorSelector}
                  visibility={product.properties.any(p=>p.name=='Emax 2 Fixed Parts') ? true: product.properties.any(p=>p.name=='Emax 2' || (p.name=='SelectorName' && p.value=="Emax 2")) && !product.configurableProduct && !onConfigure?false: product.properties.any(p=>p.name=='VD4_MB' || p.name=='iVD4_MB') && !onConfigure?false:product.configurableProduct || onConfigure || (fromSearch && product.configurableProduct )}
                  /> 
            }
            {showMobileAddToCartButtonCN!==undefined && !showMobileAddToCartButtonCN?<></>: <>{!bolReconfig &&!apttusReconfig && add &&<>
            <IconButton
                key="icon-button"
                tooltip={ translate( this.props.shoppingList ? 'Add to shopping list' : fromCart ? 'Update product in cart' : 'Add to cart' ) }
                //className={ className || (shoppingList ? "add-to-shopping-cart" : "add-to-cart-button") }
                // className = "round-button"
                className = {!this.props.fromConfigurator?classNames("round-button", "icon-bg-black"):"primary-button"}
                icon={  !this.props.fromConfigurator&&WhiteCartIconNew }
                onClick={ this.openQuantityField}
                process={ preProcessProducts( product, { 
                  warnMissingBomItems: this.confirmBomItemMissing, 
                  warnSuggestedItemNotAvailableInLocale: this.warnSuggestedItemNotAvailableInLocale 
                }, this.props.currentPage.currentPage ) }

                text={translate(this.props.fromConfigurator?text || shoppingList ? 'Shopping List' : fromCart ? 'Update product in cart' : 'Add to cart':"") }
                disabled={ add.disabled || mountedOnly }
                fromModelConfigurator = {this.props.fromModelConfigurator}
                defaultAmount = {this.props.defaultAmount}
                // hidden={ hidden }
                warnPopup = { warnPopup }
                showMandatoryWarning={this.props.siteSettings.properties.showMandatoryWarning}
                getWarningComponent = {this.getWarningComponent( properties.allSatisfied === false && product.bomItems !== undefined, product, warnPopup )}
                />
                      {
                        this.state.showQuantityField && <QuantityField 
                        amount={ quantity.amount || amount }
                        onChange={ this.changeAmount }
                        onBlur={ this.fixAmount } 
                        minOrderAmount = { this.state.minOrderAmount }
                        incrementBy = { this.state.incrementBy }
                        { ...product }
                        disabled={ quantity.disabled }
                        hidden={ quantity.hidden }
                        readonly={ quantity.readonly || product.fixedAmount }
                        fromCart={ fromCart }
                        showQuantityPopUp={true}
                        fromModelConfigurator = {fromModelConfigurator}
                        showQuantity = {this.openQuantityField}
                        addToCartButton = {<BusyContainer actions={['filter-active']}>
                          <AddToCartButton 
                          { ...add } 
                          showWarning={ properties.allSatisfied === false && product.bomItems !== undefined }
                          product={ product } 
                          process={ preProcessProducts( product, { 
                            warnMissingBomItems: this.confirmBomItemMissing, 
                            warnSuggestedItemNotAvailableInLocale: this.warnSuggestedItemNotAvailableInLocale 
                          }, this.props.currentPage.currentPage ) }
                          fromCart={ fromCart } 
                          oldProduct={ oldProduct } 
                          isPopup={ isPopup } 
                          amount={ amount }
                          onAmountChange = {this.changeAmount}
                          fromQuantityDialog = {true} 
                          fixAmountFunc={ amountFn }
                          isReadyAssembled={ isReadyAssembled } 
                          assemblyType = { assemblyType }
                          fromModelConfigurator = {this.props.fromModelConfigurator}
                          defaultAmount = {this.props.defaultAmount}
                          supercodeIdentified = { supercodeIdentified }
                          disabled = { add.disabled || mountedOnly }
                          fromSearch = { fromSearch }
                          warnPopup = { warnPopup }
                          onClose = {this.openQuantityField}
                          currentSelector={this.props.currentSelector}
                          fromLooseAccessories={this.props.fromLooseAccessories}
                          fromSearchOverlay={this.props.fromSearchOverlay}
                          mobileSearchView={this.props.mobileSearchView}
                          isEdit = {isEdit}
                          fromModelConfiguratorSelector = {this.props.fromModelConfiguratorSelector}
                          visibility={product.properties.any(p=>p.name=='Emax 2 Fixed Parts') ? true: product.properties.any(p=>p.name=='Emax 2' || (p.name=='SelectorName' && p.value=="Emax 2")) && !product.configurableProduct && !onConfigure?false: product.properties.any(p=>p.name=='VD4_MB' || p.name=='iVD4_MB') && !onConfigure?false:product.configurableProduct || onConfigure || (fromSearch && product.configurableProduct )}
                          />
                          </BusyContainer>}
                      />
                      }
          </>}</>
          }
          { apttusReconfig && <IconButton className="blue-button" icon={ downloadIcon } 
            text={ translate( 'Save To Apttus' ) } onClick={ this.apptusAction } />}
          { bolReconfig && <IconButton className="blue-button" 
            icon={ downloadIcon } text={ translate( 'Save To BOL' ) } onClick={ this.apptusAction } />} 
        </div>
        </>:<>
        <div className='mobile-cart-actions' style={{display:!this.props.showItemActions?"none":"flex"}}>
            <div className='item-actions'>
            <Box sx={{width:"100%", display:"flex",flexDirection:"row",justifyContent:"end", alignItems:"flex-end"}}>
              <Box sx={{width:"100%", display:"flex",justifyContent:"center", alignItems:"center"}}>
                <span className='header'>{translate("Item actions")}</span>
              </Box>
              {/* <Box sx={{height:"20px",position:"absolute", top:"12px", right:"12px", alignSelf:"flex-start"}}> */}
                {/* <MuiIconButton sx={{width:"20px", height:"20px"}}><Box component="img" src={mobileClosePopup} onClick={this.props.onClose}></Box></MuiIconButton> */}
              {/* </Box> */}
            <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={this.props.onClose} sx={{position:"absolute", top:"12px", right:"12px", background:"#F5F5F5",width:{md:"24px", xs:"18px"}, height:{md:"24px", xs:"18px"}, borderRadius:"56px" , backgroundColor: 'white'}}>
              <Box component="img" src={closePopup} style={{width: 'inherit', height: 'inherit'}} sx={{height:"24px", width:"24px"}}></Box>
            </MuiIconButton>
            </Box>
              <div className='actions'>
                  <QuantityField 
                  amount={ quantity.amount || amount }
                  onChange={ this.changeAmount }
                  onBlur={ this.fixAmount } 
                  minOrderAmount = { this.state.minOrderAmount }
                  incrementBy = { this.state.incrementBy }
                  { ...product }
                  disabled={ quantity.disabled }
                  hidden={ quantity.hidden }
                  readonly={ quantity.readonly || product.fixedAmount }
                  fromCart={ fromCart }
                  mobileCartView={true}
                  fromModelConfigurator = {fromModelConfigurator}
                  showQuantity = {this.openQuantityField}
                  showItemActions={this.props.showItemActions} setShowItemActions={this.props.setShowItemActions} setHideItemActions={this.props.setHideItemActions} closeDialog={this.props.onClose}
                />
                
                <Box sx={{width:"100%", border:"1px solid #DBDBDB"}}></Box>
                <><div className="items" onClick={()=>{this.toggleCommentDialog(item)}}>
                  <MuiIconButton><Box component="img" src={NoteIcon} sx={{width:"20px", height:"20px"}}></Box></MuiIconButton>
                  <span>{translate("Comment")}</span>
                </div>
                <Dialog open={this.state.showCommentDialog} onClose={this.toggleCommentDialog} PaperProps={{className:"Note-Dialog"}}>
        <div className="Note-Container">
            <Box sx={{display: "flex",
                    width: "100%",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    gap: "12px"}}>
                        {/* <IconButton onClick={props.onClose} width="24px" height="24px" sx={{position:"absolute", top:"12px", right:"12px", background:"#F5F5F5", height:"20px", width:"20px", borderRadius:"56px", backgroundColor: 'white'}}>
                            <Box component="img" src={closePopup}></Box>
                        </IconButton> */}
                        <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={()=>{this.toggleCommentDialog()}} sx={{position:"absolute", top:"12px", right:"12px", background:"#F5F5F5",width:{md:"24px", xs:"18px"}, height:{md:"24px", xs:"18px"}, borderRadius:"56px" , backgroundColor: 'white'}}>
                                <Box component="img" src={closePopup} style={{width: 'inherit', height: 'inherit'}} sx={{height:"24px", width:"24px"}}></Box>
                        </MuiIconButton>
                        <Box width="100%" sx={{display: "flex",
                                                width: "100%",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                gap: {md:"12px", xs:"24px"}}}>
                                        
                                        <Box width="100%" sx={{display:"flex", justifyContent:{md:"start", xs:"center"}}}>
                                            <span className="H5-font">{translate("comment")}</span>
                                        </Box>

                                        <input type='text' className='note_by_user' onChange={this.onCommentChange} value={this.state.comment} maxLength={this.state.maxLength}/>
                        </Box>
                        <div className="footer">
                          <div className="tertiary-button" onClick={()=>{this.toggleCommentDialog()}}>
                              <span className="cancel-btn">{translate("Cancel")}</span>
                          </div>
                          <div className="primary-button" onClick={this.saveText}>
                              <span>{translate("ADD")}</span>
                          </div>
                        </div>
                    </Box>
        </div>
        </Dialog></>
                <Box sx={{width:"100%", border:"1px solid #DBDBDB"}}></Box>

                {product.deliveryOption=="YES" &&<><div className="items">
                  <MuiIconButton><Box component="img" src={NewDeliveryIcon} sx={{width:"20px", height:"20px"}}></Box></MuiIconButton>
                  <span>{translate('Deliver as finish good')}</span>
                </div>
                                <Box sx={{width:"100%", border:"1px solid #DBDBDB"}}></Box></>
                }
                { configure && !hidden && !product.hideConfigureButton &&<>
                  <ConfigureButton { ...configure }
                          fromCart={ fromCart } 
                          product={ Object.assign(product,{amount}) } 
                          products={ products }
                          icon = {SettingsIconNew}
                          mobileCartItem = {true}
                          closeDialog = {this.props.onClose}
                            />
                  {/* <span>{translate("Configure")}</span> */}
                <Box sx={{width:"100%", border:"1px solid #DBDBDB"}}></Box></>}
                <div className="items" onClick={()=>{this.props.cloneInCart({product, amount:1}); this.props.onClose()}}>
                  <MuiIconButton><Box component="img" src={DuplicateIconNew} sx={{width:"20px", height:"20px"}}></Box></MuiIconButton>
                  <span>{translate("Duplicate")}</span>
                </div>
                <Box sx={{width:"100%", border:"1px solid #DBDBDB"}}></Box>
                <RemoveButton mobileCartView={true} setHideItemActions={this.props.setHideItemActions} closeDialog={this.props.onClose} { ...remove } product={ product } fromCart={ fromCart } onToggle={this.props.onToggle} closeItemActions={this.props.onClose}/>
              </div>
            </div>
            <div className='mobile-cart-actions-footer'>
                <div className='line'></div>
            </div>
        </div>
        </>}
        </>}
    </div>
    </>
    //  :
    //         <QuantityField 
    //           amount={ quantity.amount || this.state.amount }
    //           onChange={ this.changeAmount }
    //           onBlur={ this.fixAmount } 
    //           minOrderAmount = { this.state.minOrderAmount }
    //           incrementBy = { this.state.incrementBy }
    //           { ...product }
    //           disabled={ quantity.disabled }
    //           hidden={ quantity.hidden }
    //          readonly={ quantity.readonly || product.fixedAmount }
    //         />
    )
  }
}

ActionPanelComponent.propTypes = {
  add: PropTypes.oneOfType( [PropTypes.bool, PropTypes.object] ),
  cancel: PropTypes.oneOfType( [PropTypes.bool, PropTypes.object] ),
  className: PropTypes.string,
  clone: PropTypes.oneOfType( [PropTypes.bool, PropTypes.object] ),
  configure: PropTypes.oneOfType( [PropTypes.bool, PropTypes.object] ),
  fromCart: PropTypes.bool,
  isPopup: PropTypes.bool, 
  warning: PropTypes.bool,
  oldProduct: PropTypes.oneOfType( [PropTypes.object] ),
  product: PropTypes.oneOfType( [PropTypes.object, PropTypes.array] ).isRequired,
  products: PropTypes.shape( {} ),
  quantity: PropTypes.oneOfType( [PropTypes.bool, PropTypes.object] ),
  remove: PropTypes.oneOfType( [PropTypes.bool, PropTypes.object] ),
  superCode: PropTypes.oneOfType( [PropTypes.bool, PropTypes.object] )
};

ActionPanelComponent.contextTypes = {
  getGoToConfig: PropTypes.func,
  onAmountChange: PropTypes.func,
  properties: PropTypes.oneOfType( [PropTypes.shape( {} ), PropTypes.object] )
};

export const ActionPanel = connect( combineStates(priceState,modelConfiguratorState, identityState, productState, superCodeState,popupState, siteSettingsState, dialogState, currentNodeState,currentPageState,cartState), 
  combineDispatchers( apttusDispatcher, cartDispatcher, popupDispatcher, dialogDispatcher,modelConfiguratorDispatcher,messageDispatcher ) )( ActionPanelComponent );
